<template>
    <div class="field">
        <div v-if="isActive" class="control" v-bind:class="{ 'is-loading': isLoading }">
            <input class="input is-small" v-model="carData.query.auction_name" v-on:change="updateAuctionName()" type="text" >
        </div>
        <div v-else class="display-flex">
            <span>{{ carData.query.auction_name }}</span><span @click="makeEditable" class="pencil-edit" style="margin-left: 10px;"><i class="fa fa-pencil-alt"></i></span>
        </div>
    </div>
</template>

<script>
    import apiCars from './../../../api/apiCars'
    export default {
        props:['car'],
        data () {
            return {
                isLoading: false,
                isActive: false,
                carData:{
                    id: this.car.id,
                    query: {
                        auction_name: this.car.auction_name,
                    }
                }
            }
        },
        methods: {
            makeEditable() {
                this.isActive = true;
                return this.isActive
            },
            updateAuctionName() {
                this.isLoading = true;
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.isLoading = false
                    })
                    .catch(error => console.log(error))
            },

        },
        computed: {

        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/AuctionNameColumn.vue